// extracted by mini-css-extract-plugin
export default {"seo-data":"_3iZ--","seoData":"_3iZ--"};